.button { 
  /*position: absolute;*/
  width: 25px;
  height: 25px;
  padding-left: 7px;
  
}
